module.exports = __webpack_public_path__ + "img/customer_design_10.b1a6509.webp";